export default __webpack_public_path__ + "static/hp-brand-deck-01-54fb776b2f3b03f260d7986752489fa1.png";